import { render } from "./Terms.vue?vue&type=template&id=7755f339&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=7755f339&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7755f339"]])

export default __exports__